import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "ticketino-api-client";
import { useLanguage } from "../hooks/useLanguage";
import { useOrder } from "../hooks/useOrder";
import ticketTypesRallyCrossSelling from "../utils/ticket-types-rally-cross-seling";

import Header from "./components/Header";
import Footer from "./components/Footer";

import logoCityRally from "../images/logo_city_rally.png";

const TicketsRally = () => {
    const [resources, setResources] = useState({});
    const [quantitiesRally, setQuantitiesRally] = useState({});

    const { language } = useLanguage();

    const navigate = useNavigate();
    let baseUrl = process.env.REACT_APP_BASEURL_API;
    api.defaults.baseURL = baseUrl;

    const order = useOrder(baseUrl);

    useEffect(() => {
        loadToken();
    }, []);

    useEffect(() => {
        if (language) {
            requestResources();
        }
    }, [language]);

    const loadToken = async () => {
        const existingToken = localStorage.getItem("token");
        if (existingToken) {
            axios.defaults.headers.common["Authorization"] = "Bearer " + existingToken;
            api.defaults.headers.common["Authorization"] = "Bearer " + existingToken;
        } else {
            await axios.get("form/token").then((res) => {
                axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
                api.defaults.headers.common["Authorization"] = "Bearer " + res.data;
                localStorage.setItem("token", res.data);
            });
        }
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    // Helper to format rally dropdown text with person ranges
    const getRallyDropdownText = (qty) => {
        if (qty === 0) return '0';
        if (qty === 1) return `1 (3 - 5 ${resources?.TicketsRallyPeople})`;
        const start = (qty - 1) * 5 + 1;
        const end = qty * 5;
        return `${qty} (${start} - ${end} ${resources?.TicketsRallyPeople})`;
    };

    // Handle quantity change for City Rally tickets
    const handleQuantityChangeRally = (ticketId, value) => {
        setQuantitiesRally(prev => ({ ...prev, [ticketId]: value }));
    };

    const handleNext = () => {
        // Rally Cross-Selling: collect selected tickets
        const selectedCrossSellingTickets = ticketTypesRallyCrossSelling.items
            .filter(ticketType => ticketType.isStandAloneOnly && quantitiesRally[ticketType.id] > 0)
            .map(ticketType => ({
                externalTicketCode: ticketType.externalTicketCode,
                quantity: quantitiesRally[ticketType.id]
            }));

        // Calculate total quantity of rally tickets
        const totalRallyQuantity = selectedCrossSellingTickets.reduce((sum, t) => sum + t.quantity, 0);

        localStorage.removeItem("selectedCityRallyInfo");

        // Format City Rally tickets information for step60_information orderOption14
        let cityRallyInfo = "";
        if (selectedCrossSellingTickets.length > 0) {
            const rallyTicketNames = selectedCrossSellingTickets.map(ticket => {
                const ticketType = ticketTypesRallyCrossSelling.items.find(t => t.externalTicketCode === ticket.externalTicketCode);
                const ticketName = ticketType ? (ticketType.info.name[language] || ticketType.info.name["de"]) : ticket.externalTicketCode;
                return `${ticket.quantity}x ${ticketName}`;
            });
            cityRallyInfo = rallyTicketNames.join(", ");
        }

        if (cityRallyInfo) {
            localStorage.setItem("selectedCityRallyInfo", cityRallyInfo);
        }

        // Add City Rally Introduction ticket if total quantity of Rally tickets is 4 or more
        if (totalRallyQuantity >= 4) {
            selectedCrossSellingTickets.push({
                externalTicketCode: "city rally introduction",
                quantity: 1
            });
        }

        const sessionDataCrossSelling = {
            eventGroupId: 3553,
            tickets: selectedCrossSellingTickets
        };

        localStorage.setItem('selectedTicketsCrossSelling', JSON.stringify(sessionDataCrossSelling));

        // Birthday Tour requires an extra add-ons step before the calendar
        const hasBirthdayTour = selectedCrossSellingTickets.some(t => t.externalTicketCode === "city rally birthday rally standalone");
        navigate(`/${language}/${hasBirthdayTour ? "addons-rally-birthday" : "calendar-rally"}`);
    };

    const canProceed = ticketTypesRallyCrossSelling.items.some(ticketType => ticketType.isStandAloneOnly && quantitiesRally[ticketType.id] > 0);

    return (
        <>
            <Header language={language} pagePath="tickets/rally" pageTitle={resources?.TicketsChoose}
                ticketCount={order?.tickets?.length || 0} />

            <div className="page-container">
                <div className="container wrapper">

                    <div className="row mt-5">
                        <div className="col-12 text-center">
                            <img src={logoCityRally} alt="City Rally Logo" style={{ maxWidth: "220px", height: "auto" }} />
                        </div>
                    </div>

                    <div className="row mt-5 text-center">
                        <p className="title">Tickets</p>
                    </div>

                    <table className="mt-4 table table-no-border table-align-middle" style={{ marginBottom: 0, width: "100%" }}>
                        <tbody>
                            {ticketTypesRallyCrossSelling.items.filter(t => t.isStandAloneOnly).map((ticketType, idx) => (
                                <tr key={ticketType.id || idx}>
                                    <td>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                            <span>{ticketType.info.name[language] || ticketType.info.name["de"]}</span>
                                        </label>
                                    </td>
                                    <td colSpan={2} style={{ width: "1%", paddingRight: "0" }}>
                                        <div style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                            gap: "2rem"
                                        }}>
                                            {/*<span style={{*/}
                                            {/*    minWidth: "120px",*/}
                                            {/*    textAlign: "right",*/}
                                            {/*    textTransform: "uppercase",*/}
                                            {/*    textDecoration: "line-through",*/}
                                            {/*    color: "#888"*/}
                                            {/*}}>*/}
                                            {/*    {ticketType.currency} {ticketType.oldPrice.toFixed(2)}*/}
                                            {/*</span>*/}
                                            <span style={{ minWidth: "120px", textAlign: "right" }}>
                                                {ticketType.currency} {ticketType.price.toFixed(2)}
                                            </span>
                                            <select
                                                className="form-select qtd-select"
                                                value={quantitiesRally[ticketType.id] || 0}
                                                onChange={e => handleQuantityChangeRally(ticketType.id, Number(e.target.value))}
                                            >
                                                {[...Array((ticketType.quantity || 10) + 1).keys()].map(qty => (
                                                    <option key={qty} value={qty}>{getRallyDropdownText(qty)}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {/* Introduction City Rally Ticket Type */}
                    <div className="row mt-5 text-center">
                        <p className="title">{resources?.TicketsIntroductionCityRally}</p>
                        <p>{resources?.TicketsIntroductionCityRallyDesc}</p>
                    </div>

                    <table className="mt-4 table table-no-border table-align-middle" style={{ marginBottom: 0, width: "100%" }}>
                        <tbody>
                            <tr>
                                <td>
                                    <label style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                        <span>Einführung City Rally *</span>
                                    </label>
                                </td>
                                <td colSpan={2} style={{ width: "1%", paddingRight: "0" }}>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                        gap: "2rem"
                                    }}>
                                        <span style={{ minWidth: "120px", textAlign: "right" }}>
                                            30 CHF
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="row mt-5 text-center">
                        <p dangerouslySetInnerHTML={{ __html: resources?.TicketsIntroductionCityRallyHelpLine }}></p>
                    </div>

                    <div className="row mt-5">
                        <div className="col-6">
                            <button
                                className="btn-custom white"
                                type="submit"
                                onClick={() => navigate(-1)}
                            >
                                {resources?._Back}
                            </button>
                        </div>

                        <div className="col-6 text-end">
                            <button
                                className="btn-custom"
                                type="submit"
                                onClick={handleNext}
                                disabled={!canProceed}
                            >
                                {resources?._Next}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <Footer language={language} />
        </>
    )
}

export default TicketsRally